import type { MeResponse } from '@dnx/contracts';
import { queryOptions } from '@tanstack/react-query';
import { api, ApiError } from './api.js';

export const meQuery = queryOptions({
  queryKey: ['auth', 'me'],
  queryFn: () => api<MeResponse>('/auth/me'),
  staleTime: 60_000,
  retry: false,
});

/** Etapa pendente do login, lembrada só nesta aba (nunca guarda segredo). */
const PENDING_KEY = 'dnx:auth-next';
export const pendingStep = {
  get: (): 'mfa_setup' | 'mfa_verify' | null => {
    try {
      return sessionStorage.getItem(PENDING_KEY) as 'mfa_setup' | 'mfa_verify' | null;
    } catch {
      return null;
    }
  },
  set: (v: 'mfa_setup' | 'mfa_verify' | null) => {
    try {
      if (v) sessionStorage.setItem(PENDING_KEY, v);
      else sessionStorage.removeItem(PENDING_KEY);
    } catch {
      /* armazenamento indisponível: o fluxo segue pela resposta da API */
    }
  },
};

/** Códigos de recuperação ficam só em memória, exibidos uma vez. */
let recoveryCodes: string[] | null = null;
export const recoveryCodesStore = {
  take: () => recoveryCodes,
  set: (codes: string[] | null) => { recoveryCodes = codes; },
};

export const isAuthError = (e: unknown) =>
  e instanceof ApiError && (e.code === 'UNAUTHENTICATED' || e.code === 'MFA_REQUIRED' || e.code === 'SESSION_EXPIRED');
